import WebviewBridge from '../bridges/webview.js';

window.webviewBridge = WebviewBridge;